import {
  SELECT_CITY_REQUEST,
  SELECT_PRODUCT_REQUEST,
  SELECT_DATE_REQUEST,
  SELECT_GUEST_AMOUNT_REQUEST,
  SELECT_SORT_TYPE_REQUEST,
  SELECT_DISTANCE_REQUEST,
  SELECT_PRICE_REQUEST,
  SELECT_EXPERIENCE_REQUEST,
  REHYDRATE_STORE_REQUEST,
  UPDATE_SUGGESTIONS,
  SELECT_CITY_DEFAULT_REQUEST,
  SELECT_GUEST_AMOUNT_DEFAULT_REQUEST,
  SELECT_DATE_DEFAULT_REQUEST,
  SELECT_PRODUCT_DEFAULT_REQUEST,
  SELECT_EXPERIENCE_DEFAULT_REQUEST,
  SELECT_SORT_TYPE_DEFAULT_REQUEST,
  SELECT_DISTANCE_DEFAULT_REQUEST,
  SELECT_PRICE_DEFAULT_REQUEST,
  SELECT_PAYMENT_METHOD,
} from '../types';

export const rehydrateStore = userPreferences => ({ type: REHYDRATE_STORE_REQUEST, payload: userPreferences });

export const updateSuggestions = suggestions => ({ type: UPDATE_SUGGESTIONS, payload: suggestions });

export const selectCity = city => ({ type: SELECT_CITY_REQUEST, payload: city });
export const selectCityDefault = () => ({ type: SELECT_CITY_DEFAULT_REQUEST });

export const selectGuests = guests => ({ type: SELECT_GUEST_AMOUNT_REQUEST, payload: guests });
export const selectGuestsDefault = () => ({ type: SELECT_GUEST_AMOUNT_DEFAULT_REQUEST });

export const selectDate = date => ({ type: SELECT_DATE_REQUEST, payload: date });
export const selectDateDefault = () => ({ type: SELECT_DATE_DEFAULT_REQUEST });

export const selectProduct = product => ({ type: SELECT_PRODUCT_REQUEST, payload: product });
export const selectProductDefault = () => ({ type: SELECT_PRODUCT_DEFAULT_REQUEST });


export const selectExperience = experience => ({ type: SELECT_EXPERIENCE_REQUEST, payload: experience });
export const selectExperienceDefault = () => ({ type: SELECT_EXPERIENCE_DEFAULT_REQUEST });

export const selectSortType = sortType => ({ type: SELECT_SORT_TYPE_REQUEST, payload: sortType });
export const selectSortTypeDefault = () => ({ type: SELECT_SORT_TYPE_DEFAULT_REQUEST });

export const selectDistance = distance => ({ type: SELECT_DISTANCE_REQUEST, payload: distance });
export const selectDistanceDefault = () => ({ type: SELECT_DISTANCE_DEFAULT_REQUEST });

export const selectPrice = price => ({ type: SELECT_PRICE_REQUEST, payload: price });
export const selectPriceDefault = () => ({ type: SELECT_PRICE_DEFAULT_REQUEST });

export const selectCard = card => ({ type: SELECT_PAYMENT_METHOD, payload: card });
